import { Link } from 'react-router-dom';
import { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
  size?: 'small' | 'medium' | 'large';
}

export default function VideoCard({ video, size = 'medium' }: VideoCardProps) {
  const aspectClass = size === 'large' ? 'aspect-video' : size === 'small' ? 'aspect-[4/3]' : 'aspect-video';

  const formatViews = (views: number): string => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/article/${video.slug}`}
      className="group block"
    >
      <div className={`relative ${aspectClass} rounded-lg overflow-hidden bg-background-200 mb-3`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`蘑菇视频在线观看 - ${video.title}`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-1.5 py-0.5 rounded font-label">
          {video.duration}
        </div>
        {video.quality && video.quality.length > 0 && (
          <div className="absolute top-2 left-2">
            <span className="bg-primary-500/90 text-white text-[10px] px-1.5 py-0.5 rounded font-label">
              {video.quality[video.quality.length - 1]}
            </span>
          </div>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500">
            <i className="ri-play-fill text-2xl"></i>
          </div>
        </div>
      </div>
      <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors mb-1.5">
        {video.title}
      </h3>
      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-eye-line text-[10px]"></i>
          </div>
          {formatViews(video.views)}
        </span>
        <span className="flex items-center gap-1">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-[10px] text-secondary-500"></i>
          </div>
          {video.rating}
        </span>
        <span className="text-foreground-400">{video.publishDate}</span>
      </div>
    </Link>
  );
}